var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"material-box-items"},[_c('div',{staticClass:"material-box",on:{"click":_vm.downloadMaterial}},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.courseMaterial.name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }